import { z } from 'zod';
import { CognitoSubSchema, EmailSchema, TenantRoleSchema, TimestampSchema, UserStatusSchema, } from '../common.js';
/**
 * Per-tenant user record — see docs/data-model.md §4.2.
 * Source of truth for `role` + `status` (Cognito's `custom:role` is a mirror;
 * DDB wins on divergence per the nightly reconciliation script — Task 16+).
 */
export const TenantUserSchema = z.object({
    userId: CognitoSubSchema,
    tenantId: z.string().uuid(),
    email: EmailSchema,
    firstName: z.string().min(1).max(60),
    lastName: z.string().min(1).max(60),
    role: TenantRoleSchema,
    status: UserStatusSchema,
    mfaEnabled: z.boolean(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
    /** Cognito sub of the inviter; null for first tenant-admin (created by super-admin). */
    invitedBy: CognitoSubSchema.nullable(),
    lastLoginAt: TimestampSchema.nullable(),
});
/**
 * Subset of TenantUser exposed to other members of the same tenant.
 * Omits `tenantId` (caller already knows), `invitedBy`, internal timestamps.
 */
export const TenantUserPublicSchema = TenantUserSchema.pick({
    userId: true,
    email: true,
    firstName: true,
    lastName: true,
    role: true,
    status: true,
    mfaEnabled: true,
    lastLoginAt: true,
});
//# sourceMappingURL=tenantUser.js.map